import { qs, listen, add, remove } from "@fluorescent/dom";

import { section } from "@/glow";
import filterHandler from "@/lib/filters/filter-handler";
import filterFlyout from "@/lib/filters/filter-flyout";

const selectors = {
  partial: "[data-partial]",
  loader: ".search-template__loading",
};

const classes = {
  active: "is-active",
};

section("search", {
  onLoad() {
    const filterForm = qs("[data-filter-form]", this.container);
    this.searchParamsInitial = window.location.search.slice(1);
    this.searchParamsPrev = window.location.search.slice(1);

    if (filterForm) {
      this.partial = qs(selectors.partial, this.container);

      this.filterFlyout = filterFlyout(this.container);
      this.filterHandler = filterHandler({
        container: this.container,
        partial: this.partial,
        renderCB: this._renderView.bind(this),
      });
    }

    this.events = [
      listen(window, "popstate", event => {
        const searchParams = event.state
          ? event.state.searchParams
          : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderView(searchParams, false);
      }),
    ];
  },

  _renderView(searchParams, updateHash = true) {
    const url = `${window.location.pathname}?section_id=${this.container.dataset.sectionId}&${searchParams}`;
    const loading = qs(selectors.loader, this.container);

    add(loading, classes.active);
    this.filterFlyout.unload();

    fetch(url)
      .then(res => res.text())
      .then(res => {
        this.searchParamsPrev = searchParams;
        updateHash && this._updateURLHash(searchParams);
        const doc = new DOMParser().parseFromString(res, "text/html");
        const contents = qs(selectors.partial, doc).innerHTML;
        this.partial.innerHTML = contents;

        remove(loading, classes.active);
        this.filterFlyout = filterFlyout(this.container);
      });
  },

  _updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  },

  onUnload() {
    this.filterHandler && this.filterHandler.unload();
    this.filterFlyout && this.filterFlyout.unload();
  },
});
